import { useState, useEffect } from 'react';

// Импортируем глобальные переменные
import { globalToasts, toastListeners } from '../hooks/useToast';

export default function ToastNotifications({ lang, theme }) {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const update = () => setToasts([...globalToasts]);

    toastListeners.push(update);
    setToasts([...globalToasts]);

    return () => {
      toastListeners = toastListeners.filter(l => l !== update);
    };
  }, []);

  const themeVars = theme === "dark" 
    ? { bg: "#16213e", fg: "#ffffff" }
    : { bg: "#ffffff", fg: "#333333" };

  const removeToast = (id) => {
    const toast = globalToasts.find(t => t.id === id);
    if (toast && toast.timeoutId) clearTimeout(toast.timeoutId);

    globalToasts = globalToasts.filter(t => t.id !== id);
    setToasts([...globalToasts]);
  };

  return (
    <>
      <style>{`
        .notifications {
          position: fixed;
          top: 55px;
          right: 20px;
          z-index: 10000;
        }
        .notifications .toast {
          width: 400px;
          position: relative;
          overflow: hidden;
          list-style: none;
          border-radius: 8px;
          padding: 12px 15px; /* Уменьшили padding для компактности */
          margin-bottom: 10px;
          background: ${themeVars.bg};
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: space-between;
          animation: show_toast 0.3s ease forwards;
        }
        @keyframes show_toast {
          0% { transform: translateX(100%); }
          40% { transform: translateX(-5%); }
          80% { transform: translateX(0%); }
          100% { transform: translateX(-10px); }
        }
        .notifications .toast.hide {
          animation: hide_toast 0.3s ease forwards;
        }
        @keyframes hide_toast {
          0% { transform: translateX(-10px); }
          40% { transform: translateX(0%); }
          80% { transform: translateX(-5%); }
          100% { transform: translateX(calc(100% + 40px)); }
        }
        .toast::before {
          position: absolute;
          content: '';
          height: 3px;
          width: 100%;
          bottom: 0;
          left: 0;
          background: var(--progress);
          animation: progress 5s linear forwards;
        }
        @keyframes progress {
          100% { width: 0%; }
        }
        .toast .column {
          display: flex;
          align-items: center;
        }
        .toast .column i {
          font-size: 1.5rem; /* Уменьшили иконку */
        }
        .toast .column span {
          font-size: 1rem; /* Уменьшили текст для компактности */
          margin-left: 10px;
          color: ${themeVars.fg};
          word-wrap: break-word; /* Добавили wrap для длинного текста */
        }
        .toast i:last-child {
          color: #aeb0d7;
          cursor: pointer;
          font-size: 1.2rem; /* Уменьшили крестик */
        }
        .toast i:last-child:hover {
          color: ${themeVars.fg};
        }
        .toast.success { --progress: #0abf30; }
        .toast.success .column i { color: #0abf30; }
        .toast.error { --progress: #f24d4c; }
        .toast.error .column i { color: #f24d4c; }
        .toast.warning { --progress: #e9bd0c; }
        .toast.warning .column i { color: #e9bd0c; }
        .toast.info { --progress: #3498db; }
        .toast.info .column i { color: #3498db; }

        @media screen and (max-width: 530px) {
          .notifications { right: 10px; top: 80px; }
          .notifications .toast { width: 90vw; max-width: 380px; }
        }
        .notifications.bottom-toasts {
          top: auto;
          bottom: 20px;
        }

        .bottom-toasts .toast {
          animation: show_toast_bottom 0.5s ease forwards;
          box-shadow: 0 -6px 20px rgba(0,0,0,0.3);
          margin-top: 10px;
          padding: 12px 15px; /* Компактный padding для нижнего */
          min-height: auto; /* Не фиксируем высоту */
        }

        @keyframes show_toast_bottom {
          0% { transform: translateY(100%); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }

        .bottom-toasts .toast::before {
          top: 0;
          bottom: auto;
          animation: progress_bottom 10s linear forwards;
        }

        @keyframes progress_bottom {
          0% { height: 3px; }
          100% { height: 0; }
        }

        .bottom-toasts .fa-xmark.hidden {
          display: none;
        }

        @media screen and (max-width: 800px) {
        /* Верхние тосты */
        .notifications .toast {
          font-size: 0.8rem;
          width: 50vw;       /* ещё уже */
          max-width: 220px;  /* ограничение */
          padding: 8px 10px; /* компактнее */
        }

        .toast .column i {
          font-size: 0.7rem; /* чуть меньше иконка */
        }

        .toast .column span {
          font-size: 0.7rem; /* текст компактнее */
          margin-left: 6px;
        }

        /* Нижние тосты */
        .bottom-toasts .toast {
          width: 50vw;
          max-width: 220px;
          padding: 8px 10px;
          gap: 6px;
        }

        /* Кнопка View Profile остаётся прежней */
        .bottom-toasts .toast button {
          padding: 8px 16px;
          font-size: 0.75rem;
        }
      }

      `}</style>

      {/* Обычные тосты сверху */}
      <ul className="notifications">
        {toasts
          .filter(t => t.type !== "bottom")
          .map(toast => (
            <li
              key={toast.id}
              className={`toast ${toast.type}`}
              onClick={() => removeToast(toast.id)}
            >
              <div className="column">
                <i className={`fa-solid ${toast.icon}`}></i>
                <span>{toast.message}</span>
              </div>
              <i
                className="fa-solid fa-xmark"
                onClick={(e) => {
                  e.stopPropagation();
                  removeToast(toast.id);
                }}
              ></i>
            </li>
          ))}
      </ul>

      {/* Тосты снизу — с кнопкой перехода в профиль */}
      <ul className="notifications bottom-toasts">
        {toasts
          .filter(t => t.type === "bottom")
          .map(toast => (
            <li
              key={toast.id}
              className={`toast info`}
              style={{
                cursor: "default",
                padding: "12px 15px", /* Компактный */
                display: "flex",
                flexDirection: "column",
                gap: "8px", /* Меньше gap */
                maxWidth: "380px" /* Для мобильных */
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
                <i className="fa-solid fa-search" style={{ fontSize: "1.5rem", color: "#3498db" }}></i>
                <span style={{ flex: 1, wordWrap: "break-word" }}>{toast.message}</span>
              </div>

              {/* Кнопка перехода в профиль — компактнее */}
              <button
                onClick={() => {
                  window.location.href = "/profile";
                  removeToast(toast.id);
                }}
                style={{
                  alignSelf: "flex-end",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px", /* Меньше скругление */
                  padding: "8px 16px", /* Компактнее */
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)", /* Меньше тени */
                  transition: "transform 0.2s" /* Плавный ховер */
                }}
                onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
              >
                {lang === "fr" ? "Voir le profil" : "View Profile"}
              </button>

              {/* Прогресс-бар остаётся */}
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "3px",
                background: "#3498db",
                animation: "progress_bottom 10s linear forwards"
              }}></div>
            </li>
          ))}
      </ul>
    </>
  );
}